import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ShopifyStoreAbility extends BaseAbility {}
